/**
 * Sertifika standartları listesi
 * System Certification, Product Certification ve Quality Certification sayfalarındaki standartlar
 */

export const certificateStandards = [
  // System Certification Standards
  {
    category: 'System Certification',
    standards: [
      'ISO 9001 Quality Management System',
      'BS EN ISO 9001:2015',
      'ISO 14001 Environmental Management System',
      'ISO 45001 Occupational Health and Safety Management System',
      'ISO 22000 Food Safety Management System',
      'ISO 13485 Quality Management System for Medical Devices',
      'ISO 27001 Information Security Management System',
      'ISO 20000-1 Information Technology Service Management System',
      'ISO 27701 Personal Data Management System',
      'ISO 16949 Automotive Quality Management System',
      'ISO 50001 Energy Management System',
      'ISO 22301 Societal Security and Business Continuity Management System',
      'Fight Against Corruption with ISO 37001 Corruption Management System',
      'ISO 10002 Customer Satisfaction Management System',
      'ISO 28001 Supply Chain Security Management System',
      'ISO 22483 Tourism Quality Management System',
      'ISO 14064 Carbon Footprint Verification',
      'ISO 14046 Water Footprint Verification',
      'ISO 31000 Enterprise Risk Management System',
      'ISO 39001:2012 Road Traffic Safety Management System',
      'SA 8000 Social Responsibility Standard',
      'ISO 3834-2 Welded Manufacturing Management System',
      'EN 1090 Construction of steel and aluminum structures Technical requirements for aluminum structures standard',
      'ISO 20121 The Sustainable Event Management System',
      'ISO37001:2025 Anti-Bribery Management Systems'
    ]
  },
  // Product Certification Standards
  {
    category: 'Product Certification',
    standards: [
      'CE Certification',
      'BRC Certificate',
      'Kosher Certificate',
      'FSSC 22000 Certificate',
      'Europen Vegeterian Standard',
      'NSO-NAP7 Vegeterian Standard',
      'ISO 23662 Definitions and technical criteria for foods and food ingredients suitable for vegetarians or vegans and for labelling and claims',
      '2001/95/EEC PRODUCT SAFETY DIRECTIVE',
      '2014//68/EC PRESSURE EQUIPMENT DIRECTIVE',
      'OIC/SMIIC-1:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-2:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-3:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-4:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-5:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-6:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-7:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-8:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-9:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-10:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-11:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-12:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-13:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-14:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-15:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-16:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-17:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-18:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-19:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-20:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-21:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-22:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-23:2019 REQUIREMENTS FOR HALAL FOOD',
      'OIC/SMIIC-24:2019 REQUIREMENTS FOR HALAL FOOD',
      'USCA Organic Food Products Standard'
    ]
  },
  // Quality Certification Standards
  {
    category: 'Quality Certification',
    standards: [
      'ROHS Certificate',
      'AS 9100 Certificate',
      'GHP Certificate (Good Hygiene Practices)',
      'GMP Certificate (Good Manufacturing Practices)',
      'WRAS Certificate',
      'ISO 22716-GMP Good Manufacturing Practice (GMP) International standard for cosmetics',
      'EN ISO 16128-2:2017 Guidelines on technical definitions and criteria for natural and organic cosmetic ingredients'
    ]
  }
];

/**
 * Tüm standartları tek bir array olarak döndürür
 */
export const getAllStandards = () => {
  return certificateStandards.flatMap(category => category.standards);
};

/**
 * Standartları kategoriye göre gruplar
 */
export const getStandardsByCategory = () => {
  return certificateStandards;
};

